import styled from 'styled-components'

export const DetailsContainer = styled.div`
  background-color: ${props => props.bgColor};
  background-size: cover;
  width: cover;
  display: flex;
  flex-direction: column;
  padding: 30px 20px;
  gap: 20px;
  min-height: 100vh;

  @media (max-width: 768px){
    padding: 20px 10px;
  }
`

export const DetailsTitle = styled.p`
  color: ${props => props.color};
  font-size: 16px;
  font-weight: normal;
  margin-top: 10px;
`

export const ViewLikeCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
  color: ${props => props.colorP};

  @media (max-width: 768px){
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`

export const ViewsCard = styled.p`
  font-size: ${props => (props.colorP ? '12px' : '14px')};
  color: ${props => props.colorP};
  color: ${props => props.color};
  margin-top: ${props => (props.mt ? '10px' : '0px')}
`

export const LikesCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px){
  font-size: 1px;
  }
`

export const LikesBtn = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: #64748b;
  font-size: 13px;
  gap: 0px;
`

export const Hr = styled.hr`
  border: 0.5px solid #909090;
  width: 78vw;

  @media (max-width: 768px){
    width: 95vw;
  }
`

export const LogoCard = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  margin: 15px;

  @media (max-width: 768px){
    margin: 0px;
  }
`

export const Logo = styled.img`
  align-self: flex-start;
  width: 50px;
`

export const TextCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px){
    gap: 5px;
  }
`
